export const LINKS_TABLE_HEAD = [
  { id: 'link', label: 'Link', alignRight: false },
  { id: 'validUntil', label: 'Data até', alignRight: false },
  { id: 'used', label: 'Usado', alignRight: false },
  { id: '' },
];
